import {useCallback} from 'react';
import Delta from '@/utils/wrappers/Delta';
import {deltaClientEvents} from '@/lib/delta/deltaConstants';
import DeltaHelper from '@/services/delta/DeltaHelper';

interface UseGenericButtonPressedEventProps {
  button_name: string;
  screen_name: string;
  flow_id?: string;
  flow_name?: string;
  triggered_flow_id?: string;
  triggered_flow_name?: string;
  screen_presentation_id?: string;
}

function useGenericButtonPressedEvent() {
  const pressed = useCallback(
    ({
      button_name,
      screen_name,
      flow_id = '',
      flow_name = '',
      triggered_flow_id = '',
      triggered_flow_name = '',
      screen_presentation_id = '',
    }: UseGenericButtonPressedEventProps) => {
      Delta.sendEvent(deltaClientEvents.generic.button_pressed, {
        button_name,
        screen_name,
        flow_id,
        flow_name,
        triggered_flow_id,
        triggered_flow_name,
        screen_presentation_id:
          screen_presentation_id ||
          DeltaHelper.getActiveScreenPresented().screen_presentation_id,
      });
    },
    []
  );

  return {pressed};
}

export default useGenericButtonPressedEvent;
